import React, { memo, useContext } from 'react';
import styles from './index.module.scss';
import SwitchDate, { IndexTimeActive } from './components/SwitchDate';
import CardBox from '../../../CardBox';
import EnergyUsage from './components/EnergyUsage';
import EnergyConsumptionFlow from './components/EnergyConsumptionFlow';
import EnergyUsageCost from './components/EnergyUsageCost';
import CostAllocation from './components/CostAllocation';
import CostTrend from './components/CostTrend';
import { Dropdown } from '@maxtropy/components';
import dayjs from 'dayjs';
import { ShareDataUnityEnergyCockpitMapContext } from '../..';
import { ShareDataWrapperContext } from '../../../../index';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import classNames from 'classnames';

const LeftBox = () => {
  const { isStandardSize, loadMap } = useContext(ShareDataWrapperContext);
  const {
    timeResolution: activeKey,
    dateValue: value,
    setActiveKey,
    setValue,
    energyUsageExpanded,
    setEnergyUsageExpanded,
    energyUsageContentVisible,
  } = useContext(ShareDataUnityEnergyCockpitMapContext);

  // 展开收起功能只在非标准分辨率且地图加载时生效
  const showToggle = !isStandardSize && loadMap;
  const showEnergyUsage = isStandardSize || !loadMap || (energyUsageExpanded && energyUsageContentVisible);
  const isLargeNoMapLayout = !isStandardSize && !loadMap;

  return (
    <div className={classNames(styles.left_wrapper, isLargeNoMapLayout ? styles.left_wrapper_no_map : '')}>
      <div className={classNames(styles.container, isLargeNoMapLayout ? styles.container_no_map : '')}>
        <CardBox
          title="能源成本"
          extraContent={
            <Dropdown
              type="link"
              className={styles.dropdown_wrapper}
              getPopupContainer={() => document.getElementById('full_screen_box') ?? document.body}
              trigger={['click']}
              dropdownRender={() => (
                <div className={styles.dropdown_menu_wrapper}>
                  <SwitchDate activeKey={activeKey} value={value} setActiveKey={setActiveKey} setValue={setValue} />
                </div>
              )}
            >
              {dayjs(value).format(activeKey === IndexTimeActive.THIS_MONTH ? 'YYYY-MM' : 'YYYY')}
            </Dropdown>
          }
          className={classNames(styles.card_box, isLargeNoMapLayout ? styles.card_content_no_map : '')}
          style={{
            width: isLargeNoMapLayout || isStandardSize ? 0 : 440,
            // CardBox 默认 flex: 1；大屏展开侧栏时需固定卡片宽度，避免能源成本内容跟随父容器被拉伸。
            flex: isLargeNoMapLayout || isStandardSize ? 1 : '0 0 440px',
            paddingTop: 0,
            paddingRight: 0,
            height: isLargeNoMapLayout ? 'auto' : '100%',
            background: 'transparent',
            backdropFilter: 'none',
          }}
        >
          {/* 能源成本上半部分 */}
          <EnergyUsageCost />
          {/* 成本去向（饼图） */}
          <CostAllocation />
          {/* 成本趋势（折线图） */}
          <CostTrend />
        </CardBox>

        {/* 能源用量切换按钮 - 仅非标准分辨率且地图加载时显示 */}
        {showToggle && (
          <div className={styles.energy_usage_toggle} onClick={() => setEnergyUsageExpanded?.(!energyUsageExpanded)}>
            <div className={styles.toggle_text}>
              <span>能</span>
              <span>源</span>
              <span>用</span>
              <span>量</span>
            </div>
            <div className={styles.toggle_icon}>
              {energyUsageExpanded ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
            </div>
          </div>
        )}

        {/* 能源用量 */}
        {showEnergyUsage && (
          <CardBox
            title="能源用量"
            className={isLargeNoMapLayout ? styles.card_content_no_map : ''}
            style={{
              width: isLargeNoMapLayout || isStandardSize ? 0 : 440,
              flex: isLargeNoMapLayout || isStandardSize ? 1 : '0 0 440px',
              paddingTop: 0,
              height: isLargeNoMapLayout ? 'auto' : '100%',
              background: 'transparent',
              backdropFilter: 'none',
            }}
            extraContent={
              <span style={{ color: '#4A90E2' }}>
                {dayjs(value).format(activeKey === IndexTimeActive.THIS_MONTH ? 'YYYY-MM' : 'YYYY')}
              </span>
            }
          >
            {/* 能源用量 */}
            <EnergyUsage />
            {/* 用能流向 */}
            <EnergyConsumptionFlow />
          </CardBox>
        )}
      </div>
    </div>
  );
};

export default memo(LeftBox);
